export function partializeCore<T extends object, K extends keyof T>(state: T, keysToOmit: K[] = []): Omit<T, K> {
  return Object.fromEntries(Object.entries(state).filter(([key]) => !keysToOmit.includes(key as K))) as Omit<T, K>
}

export function mergeCore<T extends { actions: unknown }>(persistedState: any, currentState: T): T {
  if (!persistedState || typeof persistedState !== "object" || Array.isArray(persistedState)) {
    return currentState
  }

  const { actions, ...persisted } = persistedState

  return { ...currentState, ...persisted }
}
